module.exports = __webpack_public_path__ + "img/lipstick_and_perfume_3.dd4ae4c4.png";